/**
 * Video Player with Overlay
 *
 * Handles automatic video playback and overlay text display.
 * This script replaces play buttons and thumbnails with automatically playing
 * videos and adds a styled overlay with branding text.
 *
 * @module VideoPlayer
 */

/**
 * Initialise video players when the DOM is fully loaded
 */
document.addEventListener("DOMContentLoaded", function () {
  initialiseVideos();
  autoplayUploadedVideos();
  initialiseSceneTitles();
});

/**
 * Initialise all video elements on the page
 *
 * Finds all video play buttons and sets up autoplay
 */
function initialiseVideos() {
  const playButtons = document.querySelectorAll(".blk-media-play");
  playButtons.forEach(function (playButton) {
    setupVideoAutoplay(playButton);
  });
}

/**
 * Set up autoplay for a video element
 *
 * @param {HTMLElement} playButton - The play button element with video data
 */
function setupVideoAutoplay(playButton) {
  const videoUrl = playButton.getAttribute("data-url");
  const parent = playButton.parentElement;
  const img = parent.querySelector("img");
  const iframe = parent.querySelector("iframe");

  playButton.style.display = "none";
  if (img) {
    img.style.display = "none";
  }

  if (iframe) {
    let autoplayUrl = videoUrl;

    if (videoUrl.includes("?")) {
      autoplayUrl += "&autoplay=1";
    } else {
      autoplayUrl += "?autoplay=1";
    }

    autoplayUrl += "&mute=1&enablejsapi=1";

    iframe.setAttribute("src", autoplayUrl);
    iframe.style.display = "block";
  }
}

/**
 * Autoplay all uploaded video elements on the page
 * This ensures videos play automatically after a 1-second delay
 * with a fade-out effect on the image
 */
function autoplayUploadedVideos() {
  const videos = document.querySelectorAll(".blk-media video");

  videos.forEach(function (video) {
    video.style.opacity = "0";

    video.muted = true;

    setTimeout(function () {
      const mediaBlock = video.closest(".blk-media");
      if (mediaBlock) {
        const image = mediaBlock.querySelector("img");
        if (image) {
          image.style.transition = "opacity 0.5s ease-in-out";
          image.style.opacity = "0";
        }

        const playButton = mediaBlock.querySelector(".icon-play");
        if (playButton) {
          playButton.style.display = "none";
        }
      }

      video.style.transition = "opacity 0.5s ease-in-out";
      video.style.opacity = "1";

      video.play().catch(function (error) {
        console.log("Autoplay was prevented:", error);
      });
    }, 1000);

    video.addEventListener("ended", function () {
      if (video.hasAttribute("loop")) {
        video.play().catch(function (error) {
          console.log("Loop play was prevented:", error);
        });
      }
    });
  });

  const playButtons = document.querySelectorAll(".blk-media .icon-play");
  playButtons.forEach(function (playButton) {
    playButton.addEventListener("click", function () {
      const mediaBlock = playButton.closest(".blk-media");
      if (mediaBlock) {
        const video = mediaBlock.querySelector("video");
        const image = mediaBlock.querySelector("img");

        if (video) {
          playButton.style.display = "none";

          if (image) {
            image.style.transition = "opacity 0.5s ease-in-out";
            image.style.opacity = "0";
          }

          video.style.transition = "opacity 0.5s ease-in-out";
          video.style.opacity = "1";

          video.play().catch(function (error) {
            console.log("Play was prevented:", error);
            playButton.style.display = "block";
            if (image) {
              image.style.opacity = "1";
            }
            video.style.opacity = "0";
          });
        }
      }
    });
  });
}

/**
 * Initialise scene title animations
 *
 * Displays scene titles sequentially with fade in/out effects.
 * Each title shows for 5 seconds, except the last one which shows for 7 seconds.
 */
function initialiseSceneTitles() {
  const mediaBlocks = document.querySelectorAll('.blk-media');

  mediaBlocks.forEach(function(mediaBlock) {
    const sceneTitles = mediaBlock.querySelectorAll('.scene-title');

    if (sceneTitles.length === 0) return;

    let currentIndex = 0;

    // Show first title after 1 second (when video starts playing)
    setTimeout(function() {
      if (sceneTitles[0]) {
        sceneTitles[0].classList.add('active');
      }

      // Function to transition to next title
      function transitionToNext() {
        // Fade out current title
        if (sceneTitles[currentIndex]) {
          sceneTitles[currentIndex].classList.remove('active');
        }

        // Move to next title
        currentIndex = (currentIndex + 1) % sceneTitles.length;

        // Fade in next title
        if (sceneTitles[currentIndex]) {
          sceneTitles[currentIndex].classList.add('active');
        }

        // Determine delay for next transition
        // Last title (index length - 1) shows for 7 seconds, others for 5 seconds
        var delay = (currentIndex === sceneTitles.length - 1) ? 7000 : 5000;
        setTimeout(transitionToNext, delay);
      }

      // Start the first transition after 5 seconds
      setTimeout(transitionToNext, 5000);
    }, 1000); // Start after 1 second
  });
}
